import api from './api';
import { Customer } from '../types/interface';
import { db } from '../../lib/database';

const extractArray = (response: any) => {
    if (!response) return [];
    const d = (response as any).data || response;
    if (Array.isArray(d)) return d;
    if (d && Array.isArray(d.data)) return d.data;
    if (d && typeof d === 'object' && Object.keys(d).length > 0) {
        const vals = Object.values(d);
        const firstArray = vals.find(v => Array.isArray(v));
        if (firstArray) return firstArray;
    }
    return [];
};

const extractObject = (response: any) => {
    if (!response) return {};
    const d = (response as any).data || response;
    if (d && d.data && !Array.isArray(d.data)) return d.data;
    return d;
};

const customerService = {
    getAll: async (): Promise<Customer[]> => {
        if (!navigator.onLine) {
            console.log("Offline mode: loading customers from indexedDB");
            return await db.customers.toArray();
        }

        try {
            const response = await api.get('/customers');
            const data = extractArray(response) as Customer[];
            if (data.length > 0) {
                await db.customers.bulkPut(data);
            }
            return data;
        } catch (error) {
            console.log("Error fetching customers, falling back to indexedDB", error);
            return await db.customers.toArray();
        }
    },

    getById: async (id: string): Promise<Customer> => {
        const response = await api.get(`/customers/${id}`);
        return extractObject(response) as Customer;
    },

    getByPhone: async (phone: string): Promise<Customer> => {
        const response = await api.get(`/customers/phone/${phone}`);
        return extractObject(response) as Customer;
    },

    create: async (data: Partial<Customer>): Promise<Customer> => {
        const response = await api.post('/customers', data);
        return extractObject(response) as Customer;
    },

    update: async (id: string, data: Partial<Customer>): Promise<Customer> => {
        const response = await api.patch(`/customers/${id}`, data);
        return extractObject(response) as Customer;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete(`/customers/${id}`);
    }
};

export default customerService;
